export const testimonials = [
  {
    name: '晚风收信人',
    role: '追综五年 · 老观众',
    content:
      '以前刷到一件事要翻十几条热搜才拼得出来，现在打开时间线，起点和结局一眼就看到，省下的时间够我再看一期正片。',
    color: 'primary',
  },
  {
    name: '橘子汽水不加冰',
    role: '影视区内容观察者',
    content:
      '最难得的是它会把「有争议的说法」单独标出来。很多复盘号为了爽感直接下结论，这里反而克制，前后节点能对得上。',
    color: 'accent',
  },
  {
    name: '凌晨三点的猫',
    role: '音乐现场常客',
    content:
      '演唱会加场那件事我全程都在，看完时间线发现有些细节我自己都记混了。按日期排出来之后，逻辑一下就顺了。',
    color: 'secondary',
  },
  {
    name: '半勺盐的日记',
    role: '饭圈舆论研究爱好者',
    content:
      '看得出编辑是真的把传播路径走了一遍。控评什么时候开始、站子什么时候发声明，节点之间的因果讲得很清楚。',
    color: 'primary',
  },
];